/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button.clickableChat[_ngcontent-%COMP%]{position:fixed;right:10px;bottom:10px;height:50px;width:50px;cursor:pointer;border-radius:30px}button.clickableChat[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:20px;margin-left:-2px}"];
export { styles as styles };
